import { render, staticRenderFns } from "./WQtypeRadioView.vue?vue&type=template&id=41bc2838&"
import script from "./WQtypeRadioView.vue?vue&type=script&lang=ts&"
export * from "./WQtypeRadioView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports